export default __webpack_public_path__ + "static/media/t_wdt_c_1.6fa0d300.mp3";